import { useMemo } from 'react';

import map from 'lodash/map';

import { useShiftTypesGet } from '@sbv-clients/data-access-api';
import { useProLaborLevelDesignations } from '@sbv-clients/data-access-api';
import {
  Select,
  Stack,
  useTransformSelectValue,
  ShiftIcon,
} from '@sbv-clients/ui-shared';

function MyLabel(props: { shiftTypeName: string }) {
  const { UnitLaborLevel } = useProLaborLevelDesignations();

  return (
    <Stack
      spacing={2}
      direction={'row'}
      justifyContent={'space-between'}
      width={'100%'}
      minWidth={'48px'}
    >
      {UnitLaborLevel}
      <ShiftIcon
        name={props.shiftTypeName}
        customSizes={{ width: 16, height: 16 }}
      />
    </Stack>
  );
}

export function GroupByShiftsOrShiftUnits(props: {
  useContextFn: () => {
    groupBy: number;
    setGroupBy: (value: number) => void;
  };
}) {
  const { groupBy: value, setGroupBy: onChange } = props.useContextFn();
  const { data = [], isLoading } = useShiftTypesGet();
  const options = useMemo(() => {
    const v = map(data, (item) => ({
      id: item.shiftTypeId ?? 0,
      label: <MyLabel shiftTypeName={item.shiftTypeName ?? ''} />,
      value: item.shiftTypeId ?? 0,
    }));

    v.unshift({
      id: 0,
      label: <>Shift Type</>,
      value: 0,
    });
    return v;
  }, [data]);
  const handleChange = useTransformSelectValue(onChange);
  return (
    <Select
      isLoading={isLoading}
      fullWidth
      size="small"
      value={value}
      label="Group By"
      options={options}
      onChange={handleChange}
    />
  );
}
